// extracted by mini-css-extract-plugin
export default {"headerContainer":"BusinessPlanModal_headerContainer__ginuh","paneContainer":"BusinessPlanModal_paneContainer__CnSx+","form":"BusinessPlanModal_form__wZB4L"};